// extracted by mini-css-extract-plugin
export default {"eventCardsContainer":"RejectionCard_eventCardsContainer__5HcI9","eventCard":"RejectionCard_eventCard__zgbHP","eventCardImage":"RejectionCard_eventCardImage__JWoAU"};